import { getService } from 'data/function';
export class AlertProcessor {
    static get AlertService() {
        return getService('AlertService');
    }
    static async process({ message, trackingProperties, source }) {
        try {
            const { variant, icon, title, body, buttons } = message.content;
            await AlertProcessor.AlertService.show({
                variant,
                icon,
                title,
                body,
                buttons,
                callback: {
                    cancelButtonAction: () => this.alertClick(false, trackingProperties, source),
                    confirmButtonAction: () => this.alertClick(true, trackingProperties, source),
                },
            });
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
    static alertClick(response, trackingProperties, source) {
        const messageResponse = {
            response: response,
            trackingProperties,
        };
        source.postMessage(messageResponse, '*');
    }
}
